/** Anonymous landing → auth funnel (ANALYTICS-1 / LAND-1). */
const VISITOR_KEY = 'lexio_visitor_id'

export type FunnelEventType =
  | 'LANDING_VIEW'
  | 'DEMO_WORD_TAPPED'
  | 'MAGIC_SEEN'
  | 'REGISTER_CLICK'
  | 'WAITLIST_JOINED'

export const VISITOR_HEADER = 'X-Lexio-Visitor-Id'

export function getOrCreateVisitorId(): string {
  try {
    const existing = localStorage.getItem(VISITOR_KEY)
    if (existing && /^[0-9a-f-]{36}$/i.test(existing)) {
      return existing
    }
    const id = crypto.randomUUID()
    localStorage.setItem(VISITOR_KEY, id)
    return id
  } catch {
    return crypto.randomUUID()
  }
}

export function trackFunnel(
  eventType: FunnelEventType,
  metadata?: Record<string, unknown>,
): void {
  const visitorId = getOrCreateVisitorId()
  const body = JSON.stringify({
    visitorId,
    eventType,
    metadata: metadata ?? {},
  })

  // Prefer sendBeacon so navigation (register click) still delivers the event.
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' })
      if (navigator.sendBeacon('/api/analytics/events', blob)) {
        return
      }
    }
  } catch {
    // fall through to fetch
  }

  void fetch('/api/analytics/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'include',
  }).catch(() => {
    // Fire-and-forget — never block UX
  })
}

export async function joinWaitlist(email: string, source = 'landing'): Promise<void> {
  const visitorId = getOrCreateVisitorId()
  const response = await fetch('/api/waitlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, visitorId, source }),
  })
  if (!response.ok) {
    throw new Error('waitlist_failed')
  }
}
